const findCompareAtPriceRange = product => {
  const { minVariantPrice, maxVariantPrice } = product.store.priceRange;

  let min = product.store.variants[0].store.compareAtPrice;
  let max = product.store.variants[0].store.compareAtPrice;

  if (minVariantPrice < maxVariantPrice && min > 0) {
    product.store.variants.forEach(variant => {
      if (min > variant.store.compareAtPrice) {
        min = variant.store.compareAtPrice;
      }
      if (max < variant.store.compareAtPrice) {
        max = variant.store.compareAtPrice;
      }
    });
  }

  return {
    minVariantPrice: {
      amount: min,
      currencyCode: 'USD',
    },
    maxVariantPrice: {
      amount: max,
      currencyCode: 'USD',
    },
  };
};

export default findCompareAtPriceRange;
